import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "FirstWalletWidget" */ './FirstWalletWidget'),
  modules: ['./FirstWalletWidget'],
  loading: () => <div />
});

export default LoadableWidget;
